import { Session } from "@platform/ui/features";

export const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3000";

/**
 * The operator session (ADR 0012, card 012): access token in memory, refresh token in the httpOnly cookie that the
 * API scopes to `/v1/ops/auth`, 12 hours at most.
 */
export const session = new Session({ baseUrl: API_URL, client: "web", authPath: "/v1/ops/auth" });
